import React from 'react';
import { Redirect } from 'react-router-dom';

export default class NotFound extends React.Component {
  render() {
    return <Redirect to="/" />;
  }
}
